import type { Ref } from 'vue'
import { defineComponent, onBeforeMount, onBeforeUnmount, ref, watchEffect } from 'vue'
import { useLockBodyScroll } from '@/composables/useLockBodyScroll'
import { useMainStore } from '@/store/main'

export default defineComponent({
  name: 'AppPopup',
  props: {
    withoutClose: { type: Boolean, required: false },
    swipeClose: { type: Boolean, required: false },
    popupStatus: { type: Boolean, required: false },
    title: { type: String, required: false },
    icon: { type: String, required: false },
  },
  emits: ['popupClose'],
  setup(props, { emit }) {
    const { enableBodyScroll, disableBodyScroll } = useLockBodyScroll()
    const mainStore = useMainStore()
    const yDown = ref(null) as Ref<null | number>

    const popupClose = () => {
      enableBodyScroll()
      emit('popupClose')
    }

    const handleTouchStart = (event: TouchEvent) => {
      yDown.value = event.touches[0].clientY
    }

    const handleTouchMove = (event: TouchEvent) => {
      if (!yDown.value || !mainStore.isMobile || !props.swipeClose) {
        return
      }
      const yUp = event.touches[0].clientY
      const yDiff = (yDown.value as number) - yUp
      if (yDiff < 0) {
        popupClose()
      }
      yDown.value = null
    }

    const closeOnEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        popupClose()
      }
    }

    watchEffect(() => {
      if (props.popupStatus) {
        disableBodyScroll()
      }
      else {
        enableBodyScroll()
      }
    })

    onBeforeMount(() => {
      window.addEventListener('keydown', closeOnEsc)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('keydown', closeOnEsc)
      enableBodyScroll()
    })

    return {
      mainStore,
      popupClose,
      handleTouchStart,
      handleTouchMove,
    }
  },
})
